<template>
    <b-form-invalid-feedback :class="{ 'permaHeight': keepHeight }">
        {{ vc.errors[0] }}
    </b-form-invalid-feedback>
</template>

<script>
export default {
    props: {
        vc: {
            type: Object,
            required: true
        },
        keepHeight: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style scoped>
.permaHeight {
    min-height: 0.875em;
}
</style>
